var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { computePerformanceTime, mergeConfig, validateConfig, uuidv4 } from "./utils";
import { getConfig, getConfigServiceUrl, getConfigServiceUrlNonProd, performanceObserverFactory, recordMetrics, telemetryServiceUrl, telemetryServiceUrlNonProd } from './telemetry';
var KeyperClient = /** @class */ (function () {
    /**
     * Initializes and starts keyper.
     * @param config the configuration to determine what data to process.
     * @returns Keyper instance.
     */
    function KeyperClient(_a) {
        var _this = this;
        var activated = _a.activated, cfgApiURL = _a.apiURL, cfgApp = _a.app, beforeSend = _a.beforeSend, data = _a.data, cfgEnvironment = _a.environment, _b = _a.elementIds, elementIds = _b === void 0 ? [] : _b, _c = _a.navigationTypes, navigationTypes = _c === void 0 ? [] : _c, // ["back_forward", "navigate", "prerender", "reload"],
        _d = _a.paintTypes, // ["back_forward", "navigate", "prerender", "reload"],
        paintTypes = _d === void 0 ? [] : _d, // ["first-contentful-paint", "first-paint"],
        _e = _a.gqlResources, // ["first-contentful-paint", "first-paint"],
        gqlResources = _e === void 0 ? [] : _e, _f = _a.resources, resources = _f === void 0 ? [] : _f, useRemote = _a.useRemote, _g = _a.ignoreErrors, ignoreErrors = _g === void 0 ? [] : _g;
        /**
         * Internal Validity state of the local config.
         */
        this.configIsValid = false;
        /**
         * The internal user created config (from keyper-ui)
         */
        this.remoteConfig = null;
        /**
         * The internal performance observer instance.
         */
        this.observer = null;
        /**
         * Internal logger.
         */
        this.logger = {
            log: function () {
                var _data = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    _data[_i] = arguments[_i];
                }
                console.log("%s", "**KeyperLog**");
                console.log.apply(console, _data);
            },
            warn: function () {
                var _data = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    _data[_i] = arguments[_i];
                }
                console.log("%s", "**KeyperWarn**");
                console.warn.apply(console, _data);
            },
            errorTerms: {
                kind: {
                    cannotConnect: "Cannot connect",
                },
                reason: {
                    invalidConfig: "Config is invalid",
                }
            }
        };
        this.transientTransactions = [];
        /**
         * Captures performance metrics and propagates to keyper-telemetry-services.
         */
        this.capturePerformance = function (skipRemoteCheck, configType) {
            if (skipRemoteCheck === void 0) { skipRemoteCheck = false; }
            if (configType === void 0) { configType = 'local'; }
            if (_this.observer instanceof PerformanceObserver) {
                _this.disconnect();
            }
            // capture errors
            window.addEventListener('error', _this.windowOnError);
            var useLocalConfig = configType === 'local';
            // instantiate new observer
            _this.observer = performanceObserverFactory(useLocalConfig ? _this.config : _this.remoteConfig);
            // start observing
            _this.observer.observe(useLocalConfig ? _this.localConfigObserverOptions() : _this.remoteConfigObserverOptions());
            // check if we should load a remote configuration
            !skipRemoteCheck && _this.config.useRemote && (function () { return __awaiter(_this, void 0, void 0, function () {
                var cfg;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getConfig()];
                        case 1:
                            cfg = _a.sent();
                            if (!cfg.activated) { // stop if inactivated from remote.
                                return [2 /*return*/, this.disconnect()];
                            }
                            (cfg === null || cfg === void 0 ? void 0 : cfg.apiURL) && this.blockedResourceUrls.push(cfg.apiURL);
                            this.remoteConfig = this.filterBlockedUrlsFromConfig(cfg);
                            !this.remoteConfig.app &&
                                this.logger.warn("Remote config ".concat(highlightTerm("magenta", "unavailable"), ". You can add one via ").concat(highlightTerm("green", "keyper-ui"), "."));
                            this.remoteConfig = mergeConfig(this.remoteConfig, this.config);
                            this.remoteConfig = this.filterBlockedUrlsFromConfig(this.remoteConfig);
                            this.validateConfig(this.remoteConfig);
                            this.capturePerformance(true, 'remote');
                            return [2 /*return*/];
                    }
                });
            }); })();
        };
        /**
         * Computes the observer options based on the local config.
         * @returns the performance observer options
         */
        this.localConfigObserverOptions = function () {
            var _a, _b, _c, _d, _e, _f;
            return ({
                entryTypes: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (((_a = _this.config.elementIds) === null || _a === void 0 ? void 0 : _a.length) ? ["element"] : []), true), (((_b = _this.config.navigationTypes) === null || _b === void 0 ? void 0 : _b.length) ? ["navigation"] : []), true), (((_c = _this.config.paintTypes) === null || _c === void 0 ? void 0 : _c.length) ? ["paint"] : []), true), (((_d = _this.config.resources) === null || _d === void 0 ? void 0 : _d.length) ? ["resource"] : []), true), (((_f = (_e = _this.config.gqlResources) === null || _e === void 0 ? void 0 : _e.flatMap(function (curr) { return curr.opNames; })) === null || _f === void 0 ? void 0 : _f.length) ? ["measure"] : []), true)
            });
        };
        /**
         * Computes the observer options based on the remote config.
         * @returns the performance observer options
         */
        this.remoteConfigObserverOptions = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return ({
                entryTypes: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (((_b = (_a = _this.remoteConfig) === null || _a === void 0 ? void 0 : _a.elementIds) === null || _b === void 0 ? void 0 : _b.length) ? ["element"] : []), true), (((_d = (_c = _this.remoteConfig) === null || _c === void 0 ? void 0 : _c.navigationTypes) === null || _d === void 0 ? void 0 : _d.length) ? ["navigation"] : []), true), (((_f = (_e = _this.remoteConfig) === null || _e === void 0 ? void 0 : _e.paintTypes) === null || _f === void 0 ? void 0 : _f.length) ? ["paint"] : []), true), (((_h = (_g = _this.remoteConfig) === null || _g === void 0 ? void 0 : _g.resources) === null || _h === void 0 ? void 0 : _h.length) ? ["resource"] : []), true), (((_k = (_j = _this.config.gqlResources) === null || _j === void 0 ? void 0 : _j.flatMap(function (curr) { return curr.opNames; })) === null || _k === void 0 ? void 0 : _k.length) ? ["measure"] : []), true)
            });
        };
        /**
         * Filters out blocked urls from the config.
         * @param config the local or remote config.
         * @returns the sanitized config.
         */
        this.filterBlockedUrlsFromConfig = function (config) {
            var _a, _b;
            config.resources = (_a = config.resources) === null || _a === void 0 ? void 0 : _a.filter(function (r) { return !_this.blockedResourceUrls.includes(r.url); });
            config.gqlResources = (_b = config.gqlResources) === null || _b === void 0 ? void 0 : _b.filter(function (r) { return !_this.blockedResourceUrls.includes(r.endpoint); });
            return config;
        };
        /**
         * Validates the config and warns if necessary.
         * @param config
         * @returns true or false
         */
        this.validateConfig = function (config, remoteFlow) {
            if (validateConfig(config, remoteFlow) !== "valid") {
                _this.logger.warn("".concat(highlightTerm("magenta", "Invalid configuration detected.")));
                _this.configIsValid = false;
                return _this.configIsValid;
            }
            _this.configIsValid = true;
            return _this.configIsValid;
        };
        /**
         * Propagates errors to telemetry services.
         * @param event The error event.
         */
        this.windowOnError = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                // const apiURL = getApiUrl();
                ![event === null || event === void 0 ? void 0 : event.message, (_a = event === null || event === void 0 ? void 0 : event.error) === null || _a === void 0 ? void 0 : _a.message]
                    .some(function (errorMessage) { var _a, _b; return (((_a = _this.remoteConfig) === null || _a === void 0 ? void 0 : _a.ignoreErrors) || ((_b = _this.config) === null || _b === void 0 ? void 0 : _b.ignoreErrors) || []).includes(errorMessage); }) &&
                    recordMetrics([{
                            app: ((_b = this.remoteConfig) === null || _b === void 0 ? void 0 : _b.app) || this.config.app,
                            colno: event.colno,
                            environment: ((_c = this.remoteConfig) === null || _c === void 0 ? void 0 : _c.environment) || this.config.environment,
                            filename: event.filename,
                            isTrusted: event.isTrusted,
                            kind: "error",
                            lineno: event.lineno,
                            message: event.error.message,
                            name: event.message,
                            stack: event.error.stack,
                            tid: uuidv4(),
                            timestamp: computePerformanceTime(event.timeStamp)
                        }], telemetryServiceUrl, this.beforeSend);
                return [2 /*return*/];
            });
        }); };
        this.performanceCursor = 0;
        this.getPerformanceCursor = function () {
            return _this.performanceCursor;
        };
        this.setPerformanceCursor = function (position) {
            _this.performanceCursor = position;
        };
        this.getGQLMeasurementDetail = function (history, startIdx, endIdx, gqlIdx) {
            var _a, _b, _c;
            return ({
                startMark: JSON.parse(JSON.stringify((_a = (history && (history === null || history === void 0 ? void 0 : history.length) && history[startIdx])) !== null && _a !== void 0 ? _a : {})),
                endMark: JSON.parse(JSON.stringify((_b = (history && (history === null || history === void 0 ? void 0 : history.length) && history[endIdx])) !== null && _b !== void 0 ? _b : {})),
                resourceMeasurement: JSON.parse(JSON.stringify((_c = (history && (history === null || history === void 0 ? void 0 : history.length) && history[gqlIdx])) !== null && _c !== void 0 ? _c : {})),
                isGQL: true
            });
        };
        this.writeMeasurement = function (ktName, start, end, error, graphName) {
            var _a, _b, _c;
            var cursor = _this.getPerformanceCursor();
            var history = performance.getEntries();
            var gqlEndpoints = (_a = _this.config.gqlResources) === null || _a === void 0 ? void 0 : _a.flatMap(function (r) {
                return !graphName
                    ? r.endpoint
                    : r.name === graphName && r.endpoint;
            }).filter(function (v) { return !!v; });
            var startIdx = findLastIndex(history, function (e) { return e.name === start; });
            var endIdx = findLastIndex(history, function (e) { return e.name === end; });
            var gqlIdx = findLastIndex(history, function (entry, i) {
                return startIdx < i && i < endIdx && !!(gqlEndpoints === null || gqlEndpoints === void 0 ? void 0 : gqlEndpoints.find(function (gqlEp) { return entry.name.includes(gqlEp); }));
            });
            var details = _this.getGQLMeasurementDetail(history, startIdx, endIdx, gqlIdx);
            if (startIdx < gqlIdx && gqlIdx < endIdx) {
                var endTime = (_c = (_b = history[gqlIdx]) === null || _b === void 0 ? void 0 : _b.responseEnd) !== null && _c !== void 0 ? _c : undefined;
                var startTime = endTime ? undefined : history[gqlIdx].startTime;
                // @ts-ignore
                performance.measure(ktName, {
                    detail: __assign({ label: "".concat(ktName, "::Measurement"), error: error, timestamp: new Date() }, details),
                    duration: history[gqlIdx].duration,
                    start: startTime,
                    end: endTime
                });
                _this.transientTransactions = _this.transientTransactions.filter(function (t) { return t !== ktName; });
                var bestGuessLastIndex = (function () {
                    var endLastIdx = findLastIndex(__spreadArray([], performance.getEntries(), true), function (e) { return e.name === end; });
                    var ktLastIdx = findLastIndex(__spreadArray([], performance.getEntries(), true), function (e) { return e.name === ktName; });
                    return ktLastIdx > endLastIdx
                        ? ktLastIdx
                        : endLastIdx;
                })();
                var newCursor = performance.getEntries().length - 1 === endIdx
                    ? endIdx + 1
                    : bestGuessLastIndex + 1;
                _this.setPerformanceCursor(newCursor);
            }
        };
        // const { app, environment} = getCBAppDetailsFromHost();
        // const apiURL = getApiUrl();
        this.beforeSend = beforeSend;
        this.blockedResourceUrls = [getConfigServiceUrl, getConfigServiceUrlNonProd, telemetryServiceUrl, telemetryServiceUrlNonProd];
        this.config = this.filterBlockedUrlsFromConfig({
            apiURL: telemetryServiceUrl,
            app: cfgApp,
            data: data,
            environment: cfgEnvironment,
            elementIds: elementIds,
            navigationTypes: navigationTypes,
            paintTypes: paintTypes,
            gqlResources: gqlResources,
            resources: resources,
            useRemote: useRemote,
            ignoreErrors: ignoreErrors
        });
        this.validateConfig(this.config, useRemote);
        if (!this.configIsValid) {
            this.logger.warn("%s", "**keyper**::".concat(this.logger.errorTerms.kind.cannotConnect, "::").concat(this.logger.errorTerms.reason.invalidConfig));
            return;
        }
        // capture performance from local config, check remote if available,
        this.capturePerformance();
    }
    KeyperClient.prototype.getConfig = function () {
        return this.config;
    };
    KeyperClient.prototype.track = function (data) {
        var _a;
        this.config = __assign(__assign({}, this.config), { data: __assign(__assign({}, (_a = this.config) === null || _a === void 0 ? void 0 : _a.data), data) });
        this.validateConfig(this.config);
        if (!this.configIsValid) {
            this.logger.warn("%s", "**keyper**::".concat(this.logger.errorTerms.kind.cannotConnect, "::").concat(this.logger.errorTerms.reason.invalidConfig));
            return;
        }
        // capture performance
        this.capturePerformance(true);
    };
    KeyperClient.prototype.measureApolloQuery = function (ktName, queryState, graphName) {
        var _this = this;
        var _a;
        var _b = [ktName + "--START", ktName + "--END"], start = _b[0], end = _b[1];
        var preStartState = function () { return !_this.transientTransactions.includes(ktName) && !startEvent().length; };
        var preEndState = function () { return !queryState.loading && _this.transientTransactions.includes(ktName); };
        var thereIsDataOrErrors = function () { return queryState.data || queryState.error; };
        var endEvent = function () { return performance.getEntriesByName(end); };
        var startEvent = function () { return performance.getEntriesByName(start); };
        var error = (_a = queryState.error) !== null && _a !== void 0 ? _a : null;
        if (preStartState()) {
            this.transientTransactions.push(ktName);
            // @ts-ignore
            performance.mark(start, {
                detail: {
                    error: error,
                    label: "".concat(ktName, "::Apollo Client Query Started"),
                    timestamp: new Date()
                }
            });
        }
        else {
            if (preEndState() && thereIsDataOrErrors() && !endEvent().length) {
                // @ts-ignore
                performance.mark(end, {
                    detail: {
                        error: error,
                        label: "".concat(ktName, "::Apollo Client Query Complete"),
                        timestamp: new Date()
                    }
                });
                this.writeMeasurement(ktName, start, end, error, graphName);
            }
        }
        return __assign(__assign({}, queryState), { k_refetch: function (v) { return __awaiter(_this, void 0, void 0, function () {
                var res;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            // @ts-ignore
                            performance.mark(start, {
                                detail: {
                                    label: "".concat(ktName, "::Apollo Client Query Refetch Started"),
                                    timestamp: new Date(),
                                }
                            });
                            return [4 /*yield*/, queryState.refetch(v)];
                        case 1:
                            res = _c.sent();
                            // @ts-ignore
                            performance.mark(end, {
                                detail: {
                                    networkStatus: res.networkStatus,
                                    loading: res.loading,
                                    error: (_a = res.error) !== null && _a !== void 0 ? _a : null,
                                    errors: (_b = res.errors) !== null && _b !== void 0 ? _b : null,
                                    partial: res.partial,
                                    label: "".concat(ktName, "::Apollo Client Mutation Complete"),
                                    timestamp: new Date(),
                                }
                            });
                            this.writeMeasurement(ktName, start, end, error, graphName);
                            return [2 /*return*/, res];
                    }
                });
            }); } });
    };
    KeyperClient.prototype.measureLazyApolloQuery = function (ktName, lazyQueryState, graphName) {
        var _this = this;
        var _a = [ktName + "--START", ktName + "--END"], start = _a[0], end = _a[1];
        return [
            function () { return __awaiter(_this, void 0, void 0, function () {
                var res, error;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // @ts-ignore
                            performance.mark(start, {
                                detail: {
                                    label: "".concat(ktName, "::Apollo Client Lazy Query Started"),
                                    timestamp: new Date(),
                                }
                            });
                            return [4 /*yield*/, lazyQueryState[0]()];
                        case 1:
                            res = _b.sent();
                            error = (_a = res.errors) !== null && _a !== void 0 ? _a : null;
                            // @ts-ignore
                            performance.mark(end, {
                                detail: {
                                    context: res.context,
                                    error: error,
                                    extensions: res.extensions,
                                    label: "".concat(ktName, "::Apollo Client Lazy Query Complete"),
                                    timestamp: new Date(),
                                }
                            });
                            this.writeMeasurement(ktName, start, end, error, graphName);
                            return [2 /*return*/, res];
                    }
                });
            }); },
            lazyQueryState[1]
        ];
    };
    KeyperClient.prototype.measureApolloMutation = function (ktName, mutationState, graphName) {
        var _this = this;
        var _a = [ktName + "--START", ktName + "--END"], start = _a[0], end = _a[1];
        return [
            function () { return __awaiter(_this, void 0, void 0, function () {
                var res, error;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // @ts-ignore
                            performance.mark(start, {
                                detail: {
                                    label: "".concat(ktName, "::Apollo Client Mutation Started"),
                                    timestamp: new Date(),
                                }
                            });
                            return [4 /*yield*/, mutationState[0]()];
                        case 1:
                            res = _b.sent();
                            error = (_a = res.errors) !== null && _a !== void 0 ? _a : null;
                            // @ts-ignore
                            performance.mark(end, {
                                detail: {
                                    context: res.context,
                                    error: error,
                                    extensions: res.extensions,
                                    label: "".concat(ktName, "::Apollo Client Mutation Complete"),
                                    timestamp: new Date(),
                                }
                            });
                            this.writeMeasurement(ktName, start, end, error, graphName);
                            return [2 /*return*/, res];
                    }
                });
            }); },
            mutationState[1]
        ];
    };
    KeyperClient.prototype.disconnect = function () {
        this.observer.disconnect();
        window.removeEventListener('error', this.windowOnError);
    };
    return KeyperClient;
}());
/**
* Returns the index of the last element in the array where predicate is true, and -1
* otherwise.
* @param array The source array to search in
* @param predicate find calls predicate once for each element of the array, in descending
* order, until it finds one where predicate returns true. If such an element is found,
* findLastIndex immediately returns that element index. Otherwise, findLastIndex returns -1.
*/
export function findLastIndex(array, predicate) {
    var l = array.length;
    while (l--) {
        if (predicate(array[l], l, array))
            return l;
    }
    return -1;
}
var highlightTerm = function (color, msg) {
    if (color === void 0) { color = "reset"; }
    if (msg === void 0) { msg = ""; }
    return (function () {
        switch (color) {
            case "black": return "\u001B[30m".concat(msg, "\u001B[0m");
            case "blue": return "\u001B[34m".concat(msg, "\u001B[0m");
            case "cyan": return "\u001B[36m".concat(msg, "\u001B[0m");
            case "green": return "\u001B[32m".concat(msg, "\u001B[0m");
            case "magenta": return "\u001B[35m".concat(msg, "\u001B[0m");
            case "red": return "\u001B[31m".concat(msg, "\u001B[0m");
            case "reset": return "\u001B[0m".concat(msg, "\u001B[0m");
            case "white": return "\u001B[37m".concat(msg, "\u001B[0m");
            case "yellow": return "\u001B[33m".concat(msg, "\u001B[0m");
        }
    });
};
/**
 * 🔍 Keyper 🔎
 */
var Keyper = /** @class */ (function () {
    function Keyper() {
    }
    /**
     * Gets keyper instance.
     * @param config
     */
    Keyper.getInstance = function () {
        return this.instance;
    };
    /**
     * Starts keyper.
     * @param config
     */
    Keyper.watch = function (config) {
        try {
            if (!this.instance) {
                this.instance = new KeyperClient(config);
            }
        }
        catch (err) {
            console.log(err);
        }
    };
    /**
     * Adds additional data to keyper's telemetry payloads.
     * @param data
     */
    Keyper.track = function (data) {
        try {
            this.instance.track(data);
        }
        catch (err) {
            console.log(err);
        }
    };
    /**
     * Measures the performance of apollo client queries.
     * @param ktName friendly name of the key transaction.
     * @param queryState your `useQuery(...)` invocation.
     */
    Keyper.measureApolloQuery = function (ktName, queryState) {
        try {
            return this.instance.measureApolloQuery(ktName, queryState);
        }
        catch (err) {
            console.log(err);
        }
    };
    /**
     * Measures the performance of lazy apollo client queries.
     * @param ktName friendly name of the key transaction.
     * @param queryState your `useLazyQuery(...)` invocation.
     */
    Keyper.measureLazyApolloQuery = function (ktName, queryState) {
        try {
            return this.instance.measureLazyApolloQuery(ktName, queryState);
        }
        catch (err) {
            console.log(err);
        }
    };
    /**
     * Measures the performance of apollo client mutations.
     * @param ktName friendly name of the key transaction.
     * @param mutationState your `useMutation(...)` invocation.
     */
    Keyper.measureApolloMutation = function (ktName, mutationState) {
        try {
            return this.instance.measureApolloMutation(ktName, mutationState);
        }
        catch (err) {
            console.log(err);
        }
    };
    /**
     * Stops keyper.
     */
    Keyper.stop = function () {
        try {
            if (this.instance) {
                this.instance.disconnect();
                this.instance = null;
            }
        }
        catch (err) {
            console.log(err);
        }
    };
    return Keyper;
}());
export { Keyper };
//# sourceMappingURL=keyper.js.map